import { render, staticRenderFns } from "./contentSensitiveWord.vue?vue&type=template&id=67f852a2&scoped=true"
import script from "./contentSensitiveWord.vue?vue&type=script&lang=js"
export * from "./contentSensitiveWord.vue?vue&type=script&lang=js"
import style0 from "./contentSensitiveWord.vue?vue&type=style&index=0&id=67f852a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f852a2",
  null
  
)

export default component.exports